import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';
import { getBadgeColor } from '../../../utils/pro-house-account';
import { IB2BPaymentCard } from '../../../models/b2b/payments';

interface IPHABadge {
  locType: IB2BPaymentCard['locType'];
}

export const PHABadge = ({ locType }: IPHABadge) => {
  const badgeLabel = locType?.toUpperCase() === 'SHOP' ? 'Shop' : 'Project';

  return (
    <Badge
      data-testid="pha-badge"
      variant="regular"
      color={getBadgeColor(locType)}
      size="small"
    >
      {badgeLabel}
    </Badge>
  );
};
